const gates = new Set();
let inFlight = false;
let queued = false;

async function refreshGates() {
  if (inFlight) { queued = true; return; }
  inFlight = true;
  try {
    const root = window.Shopify?.routes?.root ?? '/';
    const res = await fetch(`${root}cart?view=pth-check`, { cache: 'no-store' });
    const { unlocked } = await res.json();
    gates.forEach((gate) => gate.setLocked(!unlocked));
  } catch (err) {
    console.error('pth-gate: cart check failed', err);
  } finally {
    inFlight = false;
    if (queued) { queued = false; refreshGates(); }
  }
}

class PthGate extends HTMLElement {
  connectedCallback() { gates.add(this); }
  disconnectedCallback() { gates.delete(this); }

  setLocked(locked) {
    this.toggleAttribute('data-locked', locked);
    const button = this.querySelector('button[name="add"]');
    if (button) button.disabled = locked || this.dataset.canAdd !== 'true';
  }
}

if (!customElements.get('pth-gate')) {
  customElements.define('pth-gate', PthGate);
  // Horizon 4.x dispatches this standard event on document for add / change / remove.
  // The cart is only updated once event.promise resolves.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.promise) {
      event.promise.then(refreshGates, () => {});
    } else {
      refreshGates();
    }
  });
  // Returning via the back button can show a stale cached page
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshGates(); });
}